import { defineComponent as _defineComponent } from 'vue'
import { useRestaurantModel } from '@entities/restaurant'
import ModalPayByCheck from '@/components/Modal/ModalPayByCheck.vue'
import ModalCheckPrint from '@/components/Modal/ModalCheckPrint.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentModals',
  props: {
  showConfirm: {
    type: Boolean,
    default: false
  },
  showCheckPrint: {
    type: Boolean,
    default: false
  },
  isCheckPrinting: {
    type: Boolean,
    default: true
  },
  checkPrintError: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const restaurantModel = useRestaurantModel()





return { __sfc: true,restaurantModel, ModalPayByCheck, ModalCheckPrint }
}

})